// Options '{'width':450,'height':535}'
import constants from "../../utils/constants";
import cardValidator from "card-validator";
import { submit as submitPCIProxy } from "../../components/PaymentMethods/PCIProxy/PCIProxy";
import { useDispatch } from "react-redux";
import { setSmartPaymentId } from "../BookingConfirmation/reducer";
import { updateExitStep } from "../../utils/EngineDataColllector/EngineDataCollector";
import { ExitStep } from "../../utils/EngineDataColllector/EngineData";
import React from "react";
import MapView from "../../components/MapView/MapView";

export function getPosition(options) {
  const width = options.width;
  const height = options.height;
  let left;
  let top;

  if (width) {
    if (window.outerWidth) {
      left = Math.round((window.outerWidth - width) / 2) + window.screenX;
    } else if (window.screen.width) {
      left = Math.round((window.screen.width - width) / 2);
    }
  }

  if (height) {
    if (window.outerHeight) {
      top = Math.round((window.outerHeight - height) / 2) + window.screenY;
    } else if (window.screen.height) {
      top = Math.round((window.screen.height - height) / 2);
    }
  }

  return {
    x: left,
    y: top,
  };
}

export function getActualDomain(win) {
  return `${win.location.protocol}//${win.location.host}`;
}

export function getDomain(passedWin) {
  const win = passedWin || window;

  if (!win.location.protocol) {
    throw new Error(`Can not read window protocol`);
  }

  if (win.location.protocol === "file") {
    return getActualDomain(win);
  }

  if (!win.location.host) {
    throw new Error(`Can not read window host`);
  }

  return getActualDomain(win);
}

export function isSameDomain(win) {
  try {
    return getDomain(window) === getDomain(win);
  } catch (err) {
    return false;
  }
}

function safeGet(obj, prop) {
  let result;
  try {
    result = obj[prop];
  } catch (err) {
    // pass
  }
  return result;
}

export function isWindowClosed(win, allowMock = true) {
  try {
    if (win === window) {
      return false;
    }
  } catch (err) {
    return true;
  }

  try {
    if (!win) {
      return true;
    }
  } catch (err) {
    return true;
  }

  try {
    if (win.closed) {
      return true;
    }
  } catch (err) {
    // I love you so much IE
    if (err && err.message === "Call was rejected by callee.\r\n") {
      return false;
    }
    return true;
  }

  if (allowMock && isSameDomain(win) && safeGet(win, "mockclosed")) {
    return true;
  }

  // Mobile safari
  try {
    if (!win.parent || !win.top) {
      return true;
    }
  } catch (err) {
    // pass
  }

  return false;
}

export function popup(url, options) {
  const params = Object.keys(options)
    .map(key => {
      if (options[key]) {
        return key + "=" + options[key];
      }
    })
    .filter(Boolean)
    .join(",");

  const win = window.open(url, options.name, params, !0);

  if (isWindowClosed(win)) {
    throw new Error("Can not open popup window - blocked");
  }
  return win;
}

function getInitialDimensions() {
  return {
    width: 300,
    height: 397,
  };
}

export function cleanupWindow(win) {
  if (win) {
    win.close();
  }
}

export function openPopupWindow({ url, closeCallback }) {
  const { width, height, x, y } = getInitialDimensions();

  const pos = getPosition({ width, height, x, y });
  const win = popup(url, {
    name: "payment",
    width,
    height,
    top: pos.y,
    left: pos.x,
    location: 1,
    status: 1,
    toolbar: 0,
    menubar: 0,
    resizable: 1,
    scrollbars: 1,
  });

  const interval = window.setInterval(() => {
    try {
      if (!win || win.closed) {
        window.clearInterval(interval);
        closeCallback(win);
      }
    } catch (error) {
      console.log("Error closing window" + error);
    }
  }, 1000);

  return win;
}

export function validate(values, props, formsValid) {
  const errors = {};
  const { fields, fieldConfiguration } = props;
  fields.forEach(field => {
    const [required, active, type] = [
      fieldConfiguration.get(field).get("required"),
      fieldConfiguration.get(field).get("active"),
      fieldConfiguration.get(field).get("type"),
    ];
    if (!active) {
      return;
    }
    if (required && !values[field]) {
      errors[field] = "required";
      return;
    }
    if (type === constants.FORM_FIELD_TYPES.EMAIL) {
      if (field === "repeatEmail") {
        if (values.email !== values[field]) {
          errors[field] = "invalid";
        }
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(values[field])) {
        errors[field] = "invalid";
      }
    }

    if (type === constants.FORM_FIELD_TYPES.PHONE) {
      if (!/^[0-9]+$/i.test(values[field])) {
        errors[field] = "invalid";
      }
    }

    if (type === constants.FORM_FIELD_TYPES.PHONE) {
      if (!/^[0-9]+$/i.test(values[field])) {
        errors[field] = "invalid";
      }
    }
  });
  if (props.paymentType !== constants.PAYMENT_TYPES.PCI_PROXY) {
    if (values.ccNumber) {
      if (!cardValidator.number(values.ccNumber).isValid) {
        errors.ccNumber = "invalid";
      }
    }
  }

  if (values.expirationMonth && values.expirationYear) {
    if (
      !cardValidator.expirationDate({
        month: values.expirationMonth,
        year: values.expirationYear,
      }).isValid
    ) {
      errors.expirationMonth = "invalid";
      errors.expirationYear = "invalid";
    }
  }

  const customFormValid = !Object.values(formsValid).includes(false);
  if (!customFormValid) {
    errors.customForm = "invalid";
  }
  return errors;
}

export function asyncValidate(pnpV2FormValidationErrors) {
  return new Promise((resolve, reject) => {
    function validation(event) {
      if (event && event.data) {
        window.removeEventListener("validation", validation);
        const errors = {};

        Object.keys(event.data).map(cardField => {
          if (!event.data[cardField].valid) {
            errors[cardField] = "invalid";
          }
        });

        if (Object.keys(errors).length > 0) {
          pnpV2FormValidationErrors(errors);
          reject(errors);
        }

        resolve();
      }
    }

    window.addEventListener("validation", validation);

    if (window.paylands) {
      window.paylands.validate();
    }
  });
}

function calculateMode(originalMode) {
  if (originalMode) return originalMode;
  return window ? window.isConvertActive && "17" : undefined;
}

export function handleFormSubmit({
  data,
  customFormValues,
  selectedPayment,
  propertyTicker,
  createReservation,
  defaultCurrency,
  cart,
  propertyName,
  locale,
  configuration,
  trackingData,
  stripeBridge,
  propertyContact,
  createPCIProxy,
  recaptchaToken,
  tags,
}) {
  updateExitStep(ExitStep.PAYMENT);
  const localCustomFormValues = { ...customFormValues };
  const actualPaymentType =
    selectedPayment &&
    selectedPayment.get(propertyTicker) &&
    selectedPayment.get(propertyTicker).get("type");
  const actualPaymentTicker =
    selectedPayment &&
    selectedPayment.get(propertyTicker) &&
    selectedPayment.get(propertyTicker).get("ticker");
  /*TODO: get currency*/
  createReservation({
    customFormValues: localCustomFormValues,
    formData: data,
    currency: defaultCurrency,
    cart: cart,
    paymentType: actualPaymentType,
    paymentTicker: actualPaymentTicker,
    propertyTicker: propertyTicker,
    locale: locale,
    promoCodes: configuration.get("promoCodes"),
    referrer: configuration.get("referrer"),
    affiliate: configuration.get("affiliate"),
    deviceInfo: configuration.get("deviceInfo"),
    trackingData: trackingData,
    trackerInfo: configuration.get("trackerInfo"),
    ipInfo: configuration.get("ipInfo"),
    recaptchaToken,
    tags,
    origin: configuration.get("origin"),
    mode: calculateMode(configuration.get("mode")),
  });
  if (actualPaymentType === constants.PAYMENT_TYPES.STRIPE && stripeBridge) {
    // Why are we doing this? This is not the react-way, calling a child component method directly
    // we would rather pass a prop such as isOpen to open the Stripe modal
    // however, because it is a popup inherently and it could be blocked by the browser
    // we must do this in order for the opening to occur in the same script execution context
    stripeBridge.startPaymentProcess({
      name: propertyName,
      description: (propertyContact && propertyContact.get("city")) || "",
      currency: defaultCurrency,
      locale: locale,
      amount: cart.depositTotal * 100,
      email: data && data.email,
    });
  }
  if (actualPaymentType === constants.PAYMENT_TYPES.PCI_PROXY) {
    createPCIProxy();
    submitPCIProxy();
  }
}

export function genericHandleSubmit(
  e,
  {
    formValues,
    customFormValues,
    stateUpdateFunction,
    customerFormConfiguration,
    paymentFormConfiguration,
    selectedPayment,
    propertyTicker,
    paymentType,
    createReservation,
    defaultCurrency,
    cart,
    propertyName,
    locale,
    configuration,
    trackingData,
    propertyContact,
    createPCIProxy,
    pnpV2FormValidationErrors,
    stripeBridge,
    formsValid,
    dispatch,
    id,
    smartPayment,
    recaptchaToken,
    tags,
  }
) {
  if (e) e.preventDefault();
  //Validate
  const {
    fields: customerFormFields,
    fieldConfiguration: customerFormFieldConfiguration,
  } = customerFormConfiguration;
  const {
    fields: paymentFormFields,
    fieldConfiguration: paymentFormFieldConfiguration,
  } = paymentFormConfiguration;
  const fields = [...customerFormFields, ...paymentFormFields];
  //FIXME WHAT IF NOT ARRAY
  const fieldConfiguration = (customerFormFieldConfiguration
    ? customerFormFieldConfiguration.merge(paymentFormFieldConfiguration)
    : paymentFormFieldConfiguration
  ).filter((value, key) => fields.indexOf(key) !== -1);
  const errors = validate(formValues, { fields: fields, fieldConfiguration }, formsValid);
  const touched = {};
  Object.keys(formValues).forEach(k => {
    touched[k] = "true";
  });

  // todo CHECK IF PNP / OTHER SAME VALUES; clean this up in general
  typeof stateUpdateFunction === "function" && stateUpdateFunction(errors, true, touched);
  if (Object.keys(errors).length === 0) {
    if (
      paymentType === constants.PAYMENT_TYPES.PAY_NO_PAIN_V2 ||
      paymentType === constants.PAYMENT_TYPES.PAY_NO_PAIN_PROXY
    ) {
      asyncValidate(pnpV2FormValidationErrors)
        .then(response => {
          if (smartPayment) {
            dispatch(setSmartPaymentId(id));
          } else {
            handleFormSubmit({
              data: formValues,
              customFormValues: customFormValues,
              selectedPayment,
              propertyTicker,
              createReservation,
              defaultCurrency,
              cart,
              propertyName,
              locale,
              configuration,
              trackingData,
              propertyContact,
              createPCIProxy,
              stripeBridge: stripeBridge,
              recaptchaToken,
              tags,
            });
          }
        })
        .catch(errors => {
          typeof stateUpdateFunction === "function" &&
            stateUpdateFunction(errors, undefined, undefined);
        });
    } else {
      if (smartPayment) {
        dispatch(setSmartPaymentId(id));
        if (paymentType === constants.PAYMENT_TYPES.PCI_PROXY) {
          createPCIProxy();
          submitPCIProxy();
        }
      } else {
        handleFormSubmit({
          data: formValues,
          customFormValues: customFormValues,
          selectedPayment,
          propertyTicker,
          createReservation,
          defaultCurrency,
          cart,
          propertyName,
          locale,
          configuration,
          trackingData,
          propertyContact,
          createPCIProxy,
          stripeBridge: stripeBridge,
          recaptchaToken,
          tags,
        });
      }
    }
  }
}

function generateMapView(propertyContact) {
  let mapMarker = [];
  let mapViewCenter = {
    lat: -25.363882,
    lng: 131.044922,
  };
  if (propertyContact) {
    mapMarker = [
      {
        type: "marker",
        position: new google.maps.LatLng(
          propertyContact.get("latitude"),
          propertyContact.get("longitude")
        ), // eslint-disable-line
      },
    ];
    mapViewCenter = {
      lat: propertyContact.get("latitude"),
      lng: propertyContact.get("longitude"),
    };
  }
  return <MapView initialMarkers={mapMarker} initialCenter={mapViewCenter} />;
}
export function handleMap(handleModalContent, propertyContact) {
  if (typeof handleModalContent === "function") {
    handleModalContent(generateMapView(propertyContact), {
      mobileMode: true,
      className: "wbkv9-Modal-mapModal",
    });
  }
}
